import { Key_instance180q0hqat7ybz as Key_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Key_instance2tirv2rj82ml4 as Key_instance_0 } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Element2gr7ezmxqaln7 as Element } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { Key_getInstance2js7sv2agqob1 as Key_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineDispatcher.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Runnablezd7bpy5et5p0 as Runnable } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Runnable.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function onRemove(_this__u8e3s4, action) {
  _this__u8e3s4.ea2().cd(Key_instance);
  var tmp0_safe_receiver = _this__u8e3s4.ea2().cd(Key_instance_0);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.fa3((it) => {
      action();
      return Unit_instance;
    });
  }
}
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance_1;
function Key_getInstance_0() {
  return Key_instance_1;
}
function get_key() {
  return Key_instance_1;
}
function working(reactive) {
  return this.cah(reactive);
}
var StatusListenerClass;
function StatusListener() {
  if (StatusListenerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'StatusListener', VOID, VOID, [Element()]);
    StatusListenerClass = $;
  }
  return StatusListenerClass;
}
function onThread(_this__u8e3s4, action) {
  var tmp0_elvis_lhs = _this__u8e3s4.ea2().cd(Key_getInstance());
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return action();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var d = tmp;
  if (d.qa8(_this__u8e3s4.ea2())) {
    d.ra8(_this__u8e3s4.ea2(), new (sam$kotlinx_coroutines_Runnable$0())(action));
  } else {
    action();
  }
}
var sam$kotlinx_coroutines_Runnable$0Class;
function sam$kotlinx_coroutines_Runnable$0() {
  if (sam$kotlinx_coroutines_Runnable$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.eah_1 = function_0;
      }
      ca8() {
        return this.eah_1();
      }
      i4() {
        return this.eah_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Runnable()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_Runnable$0', VOID, VOID, [Runnable(), FunctionAdapter()]);
    sam$kotlinx_coroutines_Runnable$0Class = $;
  }
  return sam$kotlinx_coroutines_Runnable$0Class;
}
//region block: init
Key_instance_1 = new (Key())();
//endregion
//region block: exports
export {
  get_key as get_keyp54t1phutrkg,
  StatusListener as StatusListener1jkchgp0onou6,
  onRemove as onRemove3k528udkni1ni,
  onThread as onThread26qoqfscmlcbk,
  Key_instance_1 as Key_instance6wd16m35aua5,
};
//endregion

//# sourceMappingURL=CalculationContext.mjs.map
